export const VERIFICATION_CODE_PLACE_HOLDER = "*******";

export const LANDING_VALID_OTP_REGEX = /^\d{6}$/;

export const LANDING_RYDE_SUPPORT_PHONE = "+972524646492";
